





















import { Component, Vue, Watch } from "vue-property-decorator";
import { Categoria, CategoriasService } from "@/services/categorias.service";
import Loading from "@/shared/components/loading.vue";
import Modal from "@/shared/components/modal.vue";
import TreeSelectCategorias from "@/shared/components/tree-select-categorias.vue";
@Component({
  components: {
    Loading,
    Modal,
    TreeSelectCategorias,
  },
})
export default class EscolherNovaCategoria extends Vue {
  categoria: Categoria | null = null;
  categoriaPai: Categoria | null = null;
  valid = false;
  loading = false;
  idCategoriaSelecionada = "";

  @Watch("idCategoriaSelecionada")
  onChange() {
    console.log(this.idCategoriaSelecionada);
  }
  required = (v: any) => {
    return !!v || "Campo obrigatório";
  };

  get tituloManter(): string {
    if (this.categoria) {
      return this.categoria.idCategoria == null
        ? "Nova Categoria"
        : "Alterar Categoria";
    }
    return "";
  }

  async salvarCategoria() {
    const modal = this.$refs.modal as Modal;
    const form = this.$refs.form as any;

    if (form.validate()) {
      this.loading = true;
      if (this.categoria) {
        await CategoriasService.excluirCategoria(
          this.categoria.idCategoria,
          this.idCategoriaSelecionada
        ).finally(() => {
          this.loading = false;
        });
      }
      this.loading = false;
      return modal.close(true);
    }
  }

  fechar() {
    const modal = this.$refs.modal as Modal;
    modal.close(false);
  }

  public async escolherNovaCategoria(id: string) {
    const modal = this.$refs.modal as Modal;
    const p = modal.open();
    this.categoriaPai = null;
    this.loading = true;
    this.categoria = await CategoriasService.obter(id);
    this.loading = false;

    return p;
  }
}
